import { useMemo } from 'react'

import { useLayoutContext } from '../../context/layoutContext'
import { rootType } from '../../types/metaModel'
import type { SpecialCasedSubTemplatedValueSetup } from './types'
import { useSpecialCasedSubTemplatedFieldVariant } from './useSpecialCasedSubTemplatedFieldVariant'
import { useSpecialSubTemplatedTemplatedConfigurations } from './useSpecialSubTemplatedTemplatedConfigurations'

type Props = {
  data: SpecialCasedSubTemplatedValueSetup
  column: number
}

export const SpecialCasedSubTemplatedFieldValueCell = ({
  data,
  column,
}: Props) => {
  const variant = useSpecialCasedSubTemplatedFieldVariant(data)
  const specialConfigurations = useSpecialSubTemplatedTemplatedConfigurations()
  const {
    preferences: {
      templates: { isShowingSimplifiedView },
    },
  } = useLayoutContext()

  type SpecialConfigurationsKeys = keyof typeof specialConfigurations

  const fieldRootType = useMemo(
    () =>
      variant?.modelType
        ? (rootType(variant.modelType) as SpecialConfigurationsKeys)
        : undefined,
    [variant?.modelType],
  )

  if (fieldRootType && !specialConfigurations[fieldRootType]) {
    throw new Error(
      `Unsupported special cased subtemplated field value: ${fieldRootType}`,
    )
  }

  const componentColumn = isShowingSimplifiedView ? column + 1 : column
  const CellComponent = fieldRootType
    ? specialConfigurations[fieldRootType].components.at(componentColumn)
    : undefined

  return !!CellComponent && <CellComponent data={data} />
}
